module.exports = __webpack_public_path__ + "img/bh-heart.252def4f.svg";